(function(window, ClickControlsViewDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.ClickControlsView = ClickControlsViewDefinition(window.$, namespace.events, namespace.mouseButtons, namespace.playerConfiguration);
})(this, function($, events, mouseButtons, playerConfiguration) {
   'use strict';

   var DEFAULT_DOUBLE_CLICK_DELAY = 300;

   var ClickControlsView = function($container, mediaElement, fullscreenView, progressBarControlView, youTube, doubleClickDelay) {
      var _$clickControls = $container.find('.click-controls');
      var _$playPauseStateContainer = $container.find('.play-pause-state');
      var _$playPauseStateIndicator = $container.find('.play-pause-state-indicator');
      var _clicks = 0;
      var _doubleClickTimer = null;
      var _enabled = true;
      var _doubleClickDelay = doubleClickDelay || DEFAULT_DOUBLE_CLICK_DELAY;

      var onClickPlay = function() {
         if (mediaElement !== youTube.player && mediaElement.currentTime !== 0) {
            mediaElement.play();
            _$playPauseStateIndicator.removeClass('pause-button-background-glyph').addClass('play-button-background-glyph');
            _$playPauseStateContainer.show().fadeOut('slow');
         }
      };

      var onClickPause = function() {
         if (mediaElement !== youTube.player && mediaElement.currentTime !== mediaElement.duration) {
            mediaElement.pause();
            _$playPauseStateIndicator.removeClass('play-button-background-glyph').addClass('pause-button-background-glyph');
            _$playPauseStateContainer.show().fadeOut('slow');
         }
      };

      var processHotspotActiveChange = function(e, eventData) {
         if (e.type === events.Hotspots.Paused && eventData && eventData.hasTimeChangeAction) {
            disable();
         } else if (e.type === events.Hotspots.Resume) {
            enable();
         }
      };

      $container.on(events.Hotspots.Paused, processHotspotActiveChange);
      $container.on(events.Hotspots.Resume, processHotspotActiveChange);

      _$clickControls.click(function(e) {
         if (!_enabled || e.button !== mouseButtons.mainButton) {
            return;
         }

         _clicks++;
         clearTimeout(_doubleClickTimer);

         if (_clicks === 1) {
            var mediaPaused = mediaElement.paused;

            _doubleClickTimer = setTimeout(function() {
               _clicks = 0;

               if (!playerConfiguration.getEnableSingleClickControl()) {
                  return;
               }

               if (mediaElement.paused === mediaPaused && !progressBarControlView.scrubbing) {
                  mediaElement.paused ? onClickPlay() : onClickPause();
               }
            }, _doubleClickDelay);
         } else if (_clicks === 2) {
            _clicks = 0;

            if (!playerConfiguration.getEnableDoubleClickControl()) {
               return;
            }

            fullscreenView.onDoubleClick();
         }
      });

      var enable = function() {
         _enabled = true;
      };

      var disable = function() {
         _enabled = false;
      };

      return {
         enable: enable,
         disable: disable
      };
   };

   return {
      create: ClickControlsView
   };
});
